const custom_fr = require('./custom.json')
export default custom_fr